'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'cat';
var width = 576;
var height = 512;
var aliases = [128008];
var unicode = 'f6be';
var svgPathData = ['M96 416l0 16c0 26.5 21.5 48 48 48l170.7 0c2.9 0 5.3-2.4 5.3-5.3 0-14.7-11.9-26.6-26.7-26.7L256 448c-7.7 0-14.2-5.5-15.7-12.8l-.3-3.2 0-40c0-22.1-17.9-40-40-40l-8 0c-8.8 0-16-7.2-16-16 0-8.8 7.2-16 16-16l8 0c39.8 0 72 32.2 72 72l0 10.1 119.1-79.4 1.9-1.1c4.6-2.2 10-2.1 14.5 .3 5.2 2.8 8.4 8.2 8.4 14.1l0 128c0 8.8 7.2 16 16 16 8.8 0 16-7.2 16-16l0-212c-10.2 2.6-21 4-32 4-47.2 0-88.4-25.5-110.6-63.5-116.9 7.5-209.4 104.7-209.4 223.5zM320 17.3L320 128c0 53 43 96 96 96s96-43 96-96l0-110.7-54 43.2c-2.8 2.3-6.4 3.5-10 3.5l-64 0c-3.6 0-7.2-1.2-10-3.5L320 17.3zM396 128a20 20 0 1 1 -40 0 20 20 0 1 1 40 0zm80 0a20 20 0 1 1 -40 0 20 20 0 1 1 40 0z', 'M519.9-29.8c4.6-2.7 10.2-2.9 15.1-.6 5.5 2.7 9.1 8.3 9.1 14.4l0 144c0 47.4-25.7 88.7-64 110.8L480 464c0 26.5-21.5 48-48 48-26.5 0-48-21.5-48-48l0-98.1-77.5 51.7c26 6 45.5 29.3 45.5 57.1 0 20.6-16.7 37.3-37.3 37.3L144 512c-44.2 0-80-35.8-80-80l0-256c0-26.5-21.5-48-48-48-8.8 0-16-7.2-16-16 0-8.8 7.2-16 16-16 44.2 0 80 35.8 80 80L96 292c39.4-71.1 111.8-121.5 196.5-130.6-2.9-10.7-4.5-21.9-4.5-33.5l0-144c0-6.1 3.5-11.7 9.1-14.4 5.5-2.7 12.1-1.9 16.9 1.9l75.6 60.5 52.8 0 75.6-60.5 1.9-1.3zM305.4 192.5C188.5 200 96 297.2 96 416l0 16c0 26.5 21.5 48 48 48l170.7 0c2.9 0 5.3-2.4 5.3-5.3 0-14.7-11.9-26.6-26.7-26.7L256 448c-7.7 0-14.2-5.5-15.7-12.8l-.3-3.2 0-40c0-22.1-17.9-40-40-40l-8 0c-8.8 0-16-7.2-16-16 0-8.8 7.2-16 16-16l8 0c39.8 0 72 32.2 72 72l0 10.1 119.1-79.4 1.9-1.1c4.6-2.2 10-2.1 14.5 .3 5.2 2.8 8.4 8.2 8.4 14.1l0 128c0 8.8 7.2 16 16 16 8.8 0 16-7.2 16-16l0-212c-10.2 2.6-21 4-32 4-47.2 0-88.4-25.5-110.6-63.5zM458 60.5c-2.8 2.3-6.4 3.5-10 3.5l-64 0c-3.6 0-7.2-1.2-10-3.5L320 17.3 320 128c0 53 43 96 96 96s96-43 96-96l0-110.7-54 43.2zM376 148a20 20 0 1 1 0-40 20 20 0 1 1 0 40zm80 0a20 20 0 1 1 0-40 20 20 0 1 1 0 40z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;